import sagas from "./saga";

export const routerModule = {
  id: "router",
  sagas: [sagas],
};
